import React, { useState, useRef } from "react";
import { fetchWithRetry } from '../utils/api';

/**
 * Компонент загрузки файлов
 */
export function FileUploader({
  uploadPort = "8000",
  acceptedFormats = ".csv,.xls,.xlsx,.json",
  endpoint = "/files/upload",
  onSuccess = () => {},
  onError = () => {},
  onComplete = () => {}
}) {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [isUploading, setIsUploading] = useState(false);
  const [expandedFileIdx, setExpandedFileIdx] = useState(null);
  const [fileDialogOpened, setFileDialogOpened] = useState(false);
  const [abortController, setAbortController] = useState(null);
  const fileInputRef = useRef(null);

  // Обработка выбора файлов (разрешить повторный выбор тех же файлов)
  const handleFileChange = (e) => {
    setFileDialogOpened(false); // сбросить флаг после выбора или отмены
    if (e.target.files.length > 0) {
      const filesArray = Array.from(e.target.files);
      setSelectedFiles(filesArray);
      setUploadProgress({});
    }
    e.target.value = null; // сброс input для повторного выбора тех же файлов
  };

  // Загрузка файлов последовательно
  const uploadAllFiles = async () => {
    setIsUploading(true);
    const controller = new AbortController();
    setAbortController(controller);

    let hasSuccessfulUploads = false;

    for (let i = 0; i < selectedFiles.length; i++) {
      if (controller.signal.aborted) break;
      await uploadFile(selectedFiles[i], i, controller.signal);

      // Проверяем, была ли успешная загрузка
      const progress = uploadProgress[i];
      if (progress && progress.status === 'completed') {
        hasSuccessfulUploads = true;
      }
    }

    setIsUploading(false);
    setAbortController(null);

    // Если были успешные загрузки, обновляем индикатор и страницу
    if (hasSuccessfulUploads) {
      // Обновляем индикатор состояния данных
      setTimeout(() => {
        // refreshDataStatus();
      }, 500);

      // Обн��вляем страницу через небольшую задержку
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  };

  const abortUpload = () => {
    if (abortController) {
      abortController.abort();
      setIsUploading(false);
      setAbortController(null);
    }
  };
  // Загрузка одного файла
  const uploadFile = async (file, index, signal) => {
    const formData = new FormData();
    formData.append('file', file, file.name);    // Определяем endpoint в зависимости от типа файла
    let uploadEndpoint;
    const fileExtension = file.name.toLowerCase().split('.').pop();
    
    if (fileExtension === 'json') {
      uploadEndpoint = '/api/packages.php'; // Для JSON пакетов
    } else {
      uploadEndpoint = '/api/files.php'; // Для CSV, XLS и других файлов
    }

    const cleanPort = uploadPort;
    const cleanEndpoint = uploadEndpoint?.startsWith('/') ? uploadEndpoint : '/files/upload';
    const uploadUrl = `http://localhost:${cleanPort}${cleanEndpoint}`;

    console.log(`Загружаем файл: ${file.name} на ${uploadUrl}`);
    setUploadProgress(prev => ({ ...prev, [index]: { status: 'uploading', progress: 0 } }));    try {
      const response = await fetch(uploadUrl, {
        method: 'POST',
        body: formData,
        signal,
      });
      
      console.log('Ответ сервера:', response);
      
      if (response.ok) {
        const data = await response.json();
        console.log('Данные ответа:', data);
        
        if (data.success) {
          setUploadProgress(prev => ({ ...prev, [index]: {
            status: 'completed',
            progress: 100,
            message: data.message,
            fileName: data.fileName,
            packageId: data.packageId
          }}));
          onSuccess(file, data);
        } else {
          setUploadProgress(prev => ({ ...prev, [index]: {
            status: 'error',
            progress: 0,
            message: data.error || 'Помилка завантаження'
          }}));
          onError(file, data.error);
        }
      } else {        const errorText = await response.text();
        setUploadProgress(prev => ({ ...prev, [index]: {
          status: 'error',
          progress: 0,
          message: `Помилка сервера: ${response.status} - ${errorText}`
        }}));
        onError(file, `Помилка сервера: ${response.status}`);
      }
      onComplete(file);    } catch (error) {
      console.error('Помилка завантаження файлу:', error);
      setUploadProgress(prev => ({ ...prev, [index]: { 
        status: 'error', 
        progress: 0, 
        message: error.message || 'Помилка завантаження файлу'
      }}));
      onError(file, error.message);
      onComplete(file);
    }
  };

  // Убираем автоматическое открытие файлового диалога при первом рендере
  // React.useEffect(() => {
  //   if (!fileDialogOpened && fileInputRef.current) {
  //     setFileDialogOpened(true);
  //   }
  // }, [fileDialogOpened]);

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const removeFile = (index) => {
    setSelectedFiles(prev => prev.filter((_, i) => i !== index));
    setUploadProgress(prev => {
      const newProgress = { ...prev };
      delete newProgress[index];
      return newProgress;
    });
  };

  const clearAllFiles = () => {
    setSelectedFiles([]);
    setUploadProgress({});
  };

  return (
    <div style={{ border: "1px dashed #d1d5db", padding: 12, borderRadius: 4, background: "#fafafa", maxWidth: "100%" }}>
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept={acceptedFormats}
        style={{ display: 'none' }}
        onClick={e => { e.target.value = null; }}
        onChange={handleFileChange}
      />
      <div style={{ display: 'flex', gap: 8, marginBottom: 18, justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
        {/* Кнопка "Выбрать файлы" - всегда активна кроме времени загрузки */}
        <button
          onClick={triggerFileInput}
          style={{
            background: !isUploading ? '#3b82f6' : '#e5e7eb',
            color: !isUploading ? '#ffffff' : '#9ca3af',
            border: !isUploading ? '2px solid #2563eb' : '2px solid #d1d5db',
            borderRadius: 6,
            flex: 1,
            minWidth: 140,
            height: 40,
            fontSize: 14,
            fontWeight: 600,
            cursor: !isUploading ? 'pointer' : 'not-allowed',
            boxShadow: !isUploading ? '0 2px 6px rgba(37, 99, 235, 0.3)' : 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease'
          }}
          disabled={isUploading}          title="Обрати файли"
        >
          Обрати файли
        </button>

        {/* Кнопка "Завантажити" - активна тільки коли є файли і немає завантаження */}
        <button
          onClick={uploadAllFiles}
          style={{
            background: (selectedFiles.length > 0 && !isUploading) ? '#10b981' : '#e5e7eb',
            color: (selectedFiles.length > 0 && !isUploading) ? '#ffffff' : '#9ca3af',
            border: (selectedFiles.length > 0 && !isUploading) ? '2px solid #059669' : '2px solid #d1d5db',
            borderRadius: 6,
            flex: 1,
            minWidth: 130,
            height: 40,
            fontSize: 14,
            fontWeight: 600,
            cursor: (selectedFiles.length > 0 && !isUploading) ? 'pointer' : 'not-allowed',
            boxShadow: (selectedFiles.length > 0 && !isUploading) ? '0 2px 6px rgba(5, 150, 105, 0.3)' : 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease'
          }}          disabled={selectedFiles.length === 0 || isUploading}
          title="Завантажити обрані файли"
        >
          Завантажити
        </button>

        {/* Кнопка "Очистити" - активна тільки коли є файли і немає завантаження */}
        <button
          onClick={clearAllFiles}
          style={{
            background: (selectedFiles.length > 0 && !isUploading) ? '#f59e0b' : '#e5e7eb',
            color: (selectedFiles.length > 0 && !isUploading) ? '#ffffff' : '#9ca3af',
            border: (selectedFiles.length > 0 && !isUploading) ? '2px solid #d97706' : '2px solid #d1d5db',
            borderRadius: 6,
            flex: 1,
            minWidth: 120,
            height: 40,
            fontSize: 14,
            fontWeight: 600,
            cursor: (selectedFiles.length > 0 && !isUploading) ? 'pointer' : 'not-allowed',
            boxShadow: (selectedFiles.length > 0 && !isUploading) ? '0 2px 6px rgba(217, 119, 6, 0.3)' : 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease'
          }}          disabled={selectedFiles.length === 0 || isUploading}
          title="Очистити список файлів"
        >
          Очистити
        </button>

        {/* Кнопка "Перервати" - активна тільки під час завантаження */}
        <button
          onClick={abortUpload}
          style={{
            background: isUploading ? '#ef4444' : '#e5e7eb',
            color: isUploading ? '#ffffff' : '#9ca3af',
            border: isUploading ? '2px solid #dc2626' : '2px solid #d1d5db',
            borderRadius: 6,
            flex: 1,
            minWidth: 120,
            height: 40,
            fontSize: 14,
            fontWeight: 600,
            cursor: isUploading ? 'pointer' : 'not-allowed',
            boxShadow: isUploading ? '0 2px 6px rgba(220, 38, 38, 0.3)' : 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease'
          }}          disabled={!isUploading}
          title="Перервати завантаження"
        >
          Перервати
        </button>
      </div>

      {/* Индикатор состояния */}
      <div style={{
        marginBottom: 12,
        padding: '8px 12px',
        background: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: 6,
        fontSize: 13,
        color: '#475569',
        textAlign: 'center',
        fontWeight: 500
      }}>        {isUploading ? (
          <span style={{ color: '#ef4444', fontWeight: 600 }}>Йде завантаження файлів...</span>
        ) : selectedFiles.length > 0 ? (
          <span style={{ color: '#10b981', fontWeight: 600 }}>Обрано файлів: {selectedFiles.length}</span>
        ) : (
          <span style={{ color: '#64748b' }}>Оберіть файли для завантаження</span>
        )}
      </div>

      {selectedFiles.length > 0 && (
        <>
          <div style={{ maxHeight: 180, overflowY: "auto", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 4 }}>
            {selectedFiles.map((file, idx) => (
              <div
                key={file.name + idx}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "6px 10px",
                  borderBottom: idx < selectedFiles.length - 1 ? "1px solid #e5e7eb" : "none",
                  fontSize: 13,
                  cursor: 'pointer',
                  background: uploadProgress[idx]?.status === 'error' ? '#fee2e2' : undefined,
                  borderLeft: uploadProgress[idx]?.status === 'error' ? '4px solid #ef4444' : undefined
                }}
                onClick={() => setExpandedFileIdx(expandedFileIdx === idx ? null : idx)}
              >
                <span title={file.name} style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{file.name}</span>
                <span style={{ color: "#9ca3af", marginLeft: 8 }}>{(file.size / 1024).toFixed(1)} KB</span>
                {uploadProgress[idx] && uploadProgress[idx].status === 'uploading' && (
                  <span style={{ color: "#4f46e5", marginLeft: 8 }}>Загрузка... {uploadProgress[idx].progress}%</span>
                )}
                {uploadProgress[idx] && uploadProgress[idx].status === 'completed' && (
                  <span style={{ color: "green", marginLeft: 8 }}>✓</span>
                )}
                {uploadProgress[idx] && uploadProgress[idx].status === 'error' && (
                  <span style={{ color: "red", marginLeft: 8 }} title={uploadProgress[idx].message}>✗</span>
                )}
                {uploadProgress[idx] && uploadProgress[idx].status === 'duplicate' && (
                  <span style={{ color: "orange", marginLeft: 8 }} title={uploadProgress[idx].message}>⚠️</span>
                )}
                <button onClick={e => { e.stopPropagation(); removeFile(idx); }} style={{ border: "none", background: "none", color: "#ef4444", cursor: "pointer", fontSize: 16, marginLeft: 8 }}>×</button>
              </div>
            ))}
          </div>
          {/* Панель с результатом загрузки выбранного файла */}
          {typeof expandedFileIdx === 'number' && uploadProgress[expandedFileIdx] && (
            <div style={{
              background: '#f9fafb',
              border: '1px solid #e5e7eb',
              borderRadius: 4,
              margin: '16px 0 0 0',
              padding: 16,
              fontSize: 14,
              boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
            }}>              <div style={{ marginBottom: 8 }}><b>Файл:</b> {selectedFiles[expandedFileIdx]?.name}</div>
              <div style={{ marginBottom: 8 }}><b>Повідомлення:</b> {uploadProgress[expandedFileIdx].message}</div>
              {typeof uploadProgress[expandedFileIdx].processed_count === 'number' && (
                <div style={{ marginBottom: 8 }}><b>Завантажено записів:</b> {uploadProgress[expandedFileIdx].processed_count}</div>
              )}
              {uploadProgress[expandedFileIdx].errors && uploadProgress[expandedFileIdx].errors.length > 0 && (
                <div style={{ background: '#fee2e2', color: '#ef4444', marginTop: 6, borderRadius: 4, padding: 8 }}>
                  <b>Помилки:</b>
                  <ul style={{ margin: 0, paddingLeft: 18 }}>
                    {uploadProgress[expandedFileIdx].errors.map((err, i) => <li key={i}>{err}</li>)}
                  </ul>
                </div>
              )}
              {uploadProgress[expandedFileIdx].warnings && uploadProgress[expandedFileIdx].warnings.length > 0 && (                <div style={{ background: '#fef9c3', color: '#f59e42', marginTop: 6, borderRadius: 4, padding: 8 }}>
                  <b>Попередження:</b>
                  <ul style={{ margin: 0, paddingLeft: 18 }}>
                    {uploadProgress[expandedFileIdx].warnings.map((warn, i) => <li key={i}>{warn}</li>)}
                  </ul>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default FileUploader;
